<div *notAllowedPermissions="['incompleteLogin', 'mustSetupAuthenticator']" class="layout-main">
  <div class="container-fluid">
    <div class="row-fluid">
      <div id="sf_admin_container">
        <div class="pb-2 mb-3">
          <h3>
            <b>{{ currentUser.company.name }}</b>
          </h3>
          <h6>
            <b> Welcome to {{ utilsService.getBrandName() }} portal </b>
            <div *ngIf="isExpiredNDA" class="alert alert-warning alert-dismissible fade show mt-3">
              It looks like your NDA with us has expired. Please make sure to renew it to have full access to our
              Portal's functionalities.
            </div>
          </h6>
        </div>
        <p-tabView (onChange)="onChange($event)">
          <p-tabPanel header="Information">
            <app-information [currentUser]="currentUser" [selected]="informationSelected"></app-information>
          </p-tabPanel>
          <ng-container *notAllowedPermissions="['isCompanyVendor']">
            <p-tabPanel *ngIf="hasMckayStatus" header="Bandwidth summary">
              <app-bandwidth-summary [currentUser]="currentUser" [selected]="bwSummarySelected"></app-bandwidth-summary>
            </p-tabPanel>
            <p-tabPanel *ngIf="hasQuincyStatus" header="Market Data summary">
              <app-market-data-summary [currentUser]="currentUser"
                                       [selected]="mdSummarySelected"></app-market-data-summary>
            </p-tabPanel>
          </ng-container>
        </p-tabView>
      </div>
    </div>
  </div>
</div>
